var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-empty',{attrs:{"description":"404 | Đường dẫn không tồn tại"}})
}
var staticRenderFns = []

export { render, staticRenderFns }